import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fe4f608"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-two" }
const _hoisted_2 = { class: "btn-group" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("撤销申请")

import { ApproveSave } from '@/apis/approval'
import { Dialog, Toast } from 'vant'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  typeId: {
    type: Number,
    default: 0 //id
  },
  itemId: {
    type: Number,
    default: 0 //id
  }
},
  setup(__props) {

const props = __props

const router = useRouter()


const to_cancel = () => {
  Dialog.confirm({
    title: '确认撤销“费用报销”吗？',
    confirmButtonText: '确定撤销',
    cancelButtonText: '取消'
  })
    .then(async () => {
      // on confirm
      console.log('结束当前')
      let data = {
        type: props.typeId,
        item_id: props.itemId,
        state: 3
      }
      const res = await ApproveSave(data)
      if (res.code === 200) {
        Toast.success({
          message: res.msg,
          duration: 500,
          onClose: () => {
            router.back()
          }
        })
      } else {
        Toast(res.msg)
      }
    })
    .catch(() => {
      // on cancel
      console.log('去重新申请')
    })
}

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_button, {
          type: "default",
          round: "",
          class: "btn-group-button consent",
          onClick: to_cancel
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})